import * as React from 'react'
import SubmitButton from '../Buttons/SubmitButton'
import FormTag from '../Templates/FormTag'
import {useTranslation} from 'react-i18next'
import LanguageField from '../Fields/LanguageField'
import ValueTrackFields from '../ValueTrack/ValueTrackFields'
import {PresentationFormSubmitted} from '../../../helpers/gtm/gtmEvents'
import {removeValueTrackCookie} from '../../../helpers/valueTrack'
import useHtmlForm from '../../../hooks/useHtmlForm'
import * as paths from '../../../constants/paths'
import FormCheck from '../Templates/FormCheck'
import FormTitle from '../Templates/FormTitle'
import FormSubtitle from '../Templates/FormSubtitle'
import PresentationFormVisibleFormFields from './PresentationFormVisibleFormFields'

type Props = {
    showNewsletter?: boolean
    partnerRef?: string
}

const PresentationForm = ({showNewsletter = true, partnerRef}: Props) => {
    const {t} = useTranslation()

    const {isSubmitted, formRef, hasError, submit} = useHtmlForm(paths.PRESENTATION_FORM, (responseData, formData) => {
        PresentationFormSubmitted(responseData, formData)
        removeValueTrackCookie()
    })

    const titleTextId = isSubmitted ? 'presentation_title_submitted' : 'presentation_title'
    const subtitleTextId = isSubmitted ? 'presentation_subtitle_submitted' : 'presentation_subtitle'

    return (
        <div>
            <div>
                <FormCheck isSubmitted={isSubmitted} />
                <FormTitle isSubmitted={isSubmitted}>{t(titleTextId)}</FormTitle>
                <FormSubtitle isSubmitted={isSubmitted}>{t(subtitleTextId)}</FormSubtitle>
            </div>
            {!isSubmitted && (
                <FormTag id={'presentation-form'} ref={formRef}>
                    <input name={'partner_ref'} type="hidden" value={partnerRef} />
                    <ValueTrackFields />
                    <LanguageField />
                    <PresentationFormVisibleFormFields showNewsletter={showNewsletter} />
                    {hasError && <p className="has-text-primary">{t('presentation-page-error')}</p>}
                    <SubmitButton
                        buttonId="system_presentation2"
                        onClick={submit}
                        size={'is-large'}
                        label={t('presentation_submit')}
                    />
                </FormTag>
            )}
        </div>
    )
}

export default PresentationForm
